import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import QuoteCard from './QuoteCard';
import SubmitForm from './SubmitForm';

function Body({ language }) {
  const [quotes, setQuotes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const quotesPerPage = 10;
  const location = useLocation();

  useEffect(() => {
    const fetchQuotes = async () => {
      try {
        setIsLoading(true);
        let quotesFile;
        
        switch(language) {
          case 'en':
            quotesFile = '/quotes_en.json';
            break;
          case 'fr':
            quotesFile = '/quotes_fr.json';
            break;
          default: // 'ar' ou autre
            quotesFile = '/quotes.json';
        }
        
        const response = await fetch(quotesFile);
        if (!response.ok) {
          throw new Error('Failed to fetch quotes');
        }
        const data = await response.json();
        setQuotes(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchQuotes();
  }, [language]);

  useEffect(() => {
    if (location.hash === '#submit') {
      const submitElement = document.getElementById('submit');
      if (submitElement) {
        submitElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const totalPages = Math.ceil(quotes.length / quotesPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const displayedQuotes = quotes.slice(
    (currentPage - 1) * quotesPerPage,
    currentPage * quotesPerPage
  );

  if (isLoading) {
    return <div className="loading">
      {language === 'en' ? 'Loading quotes...' : 
       language === 'fr' ? 'Chargement des citations...' : 
       'جاري تحميل الحكم...'}
    </div>;
  }

  if (error) {
    return <div className="error">
      {language === 'en' ? `Error: ${error}` : 
       language === 'fr' ? `Erreur: ${error}` : 
       `خطأ: ${error}`}
    </div>;
  }

  // Textes traduits
  const translations = {
    noQuotes: {
      en: 'No quotes available',
      fr: 'Aucune citation disponible',
      ar: 'لا توجد حكم متاحة'
    },
    addWisdom: {
      en: 'Add Wisdom',
      fr: 'Ajouter une sagesse',
      ar: 'إضافة حكمة'
    }
  };

  return (
    <main className="quote-container">
      {quotes.length === 0 ? (
        <div className={`no-quotes ${['en', 'fr'].includes(language) ? 'english-text' : ''}`}>
          {translations.noQuotes[language] || translations.noQuotes.ar}
        </div>
      ) : (
        displayedQuotes.map((quote, index) => (
          <QuoteCard
            key={`quote-${index}`}
            quote={quote.quote}
            author={quote.author}
            authenticity={quote.authenticity}
            language={language} 
          />
        ))
      )}
      {totalPages > 1 && (
        <div className="pagination">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`page-button ${currentPage === index + 1 ? 'active' : ''} ${['en', 'fr'].includes(language) ? 'english-text' : ''}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
      <div className="button-container">
        <button
          id="submit"
          className={`contribute-button ${['en', 'fr'].includes(language) ? 'english-text' : ''}`}
          onClick={() => setShowForm((prev) => !prev)}
        >
          {translations.addWisdom[language] || translations.addWisdom.ar}
        </button>
        {showForm && <SubmitForm language={language} />}
      </div>
    </main>
  );
}

export default Body;